import React from "react";
import "./Content.css";
import loginImg from "../../../img/login/login.jpg";
import hierarchy from "../../../img/login/hierarchy.svg";
import lightBulb from "../../../img/login/light-bulb.svg";
import trophy from "../../../img/login/trophy.svg";
import mayorArrow from "../../../img/login/LogoMayorQ.svg";
import minorArrow from "../../../img/login/LogoMenoQ.svg";

const Content = (props) => {
  const imageUrl = loginImg;
  let style = {
    backgroundImage: `url(${imageUrl})`,
  };

  const arrows = (
    <>
      <div className="arrow-container">
        <div className="arrow-relative-l">
          <div>
            <img
              alt="lightBulb"
              src={mayorArrow}
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
          </div>
        </div>

        <div className="content-text-container">
          <p className="text-mei">
              <b>MEIPresval</b> es un servicio integral para la negociación y
            administración de Préstamo de Valores.
          </p>
        </div>
        <div className="arrow-relative-r">
          <div>
            <img
              alt="lightBulb"
              src={minorArrow}
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className="container-content">
      <div className="image-login-container">
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "inline",
            overflow: "hidden",
          }}
        >
          <div style={style} className={["image-login"]}></div>
          <div className="content-relative">
            <div className="content-color">
              <div className="grid-color">
                <div
                  style={{ height: "38%", width: "100%", textAlign: "center" }}
                >
                  <img
                    alt="lightBulb"
                    src={lightBulb}
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <div
                  style={{ height: "62%", width: "100%", verticalAlign: "top" }}
                >
                  <p
                    style={{
                      color: "white",
                      fontSize: "15px",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      textAlign: "center",
                    }}
                  >
                    Innovación <br /> tecnológica
                  </p>
                </div>
              </div>
              <div className="grid-color">
                <div
                  style={{ height: "38%", width: "100%", textAlign: "center" }}
                >
                  <img
                    alt="trophy"
                    src={trophy}
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <div style={{ height: "62%", width: "100%" }}>
                  <p
                    style={{
                      color: "white",
                      fontSize: "15px",
                      maxWidth: "100%",
                      textAlign: "center",
                    }}
                  >
                    Calidad <br /> en el servicio
                  </p>
                </div>
              </div>
              <div className="grid-color">
                <div
                  style={{ height: "38%", width: "100%", textAlign: "center" }}
                >
                  <img
                    alt="hierarchy"
                    src={hierarchy}
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <div style={{ height: "62%", width: "100%" }}>
                  <p
                    style={{
                      color: "white",
                      fontSize: "15px",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      textAlign: "center",
                    }}
                  >
                    Administración de garantías segura y eficiente
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {arrows}
    </div>
  );
};

export default Content;
